import { Exclude, Expose, Transform } from 'class-transformer';
import { CaptionToggleType, CaptionType } from '../interfaces/caption-type';
import { UrlDTO } from './url.dto';
import { UserMediaAssetMetadataDTO } from './user-media-asset-metadata.tdo';

interface DefaultMetaData {
  id: number | null;
  name: string;
  value: string;
}

export const defaultMetaData: DefaultMetaData[] = [
  {
    id: null,
    name: CaptionType.TIKTOK,
    value: ''
  },
  {
    id: null,
    name: CaptionType.INSTAGRAM,
    value: ''
  },
  {
    id: null,
    name: CaptionType.YOUTUBE,
    value: ''
  },
  {
    id: null,
    name: CaptionType.PINTEREST,
    value: ''
  },
  {
    id: null,
    name: CaptionToggleType.TIKTOK,
    value: 'true'
  },
  {
    id: null,
    name: CaptionToggleType.INSTAGRAM,
    value: 'false'
  },
  {
    id: null,
    name: CaptionToggleType.YOUTUBE,
    value: 'false'
  },
  {
    id: null,
    name: CaptionToggleType.PINTEREST,
    value: 'false'
  }
];
@Exclude()
export class UserMediaAssetDTO {
  @Expose()
  id: string;

  @Expose()
  tag: string;

  @Expose()
  cdnId: string;

  @Expose()
  title: string;

  @Expose()
  caption: string;

  @Expose()
  isCustomize: boolean;

  @Expose()
  contentType: string;

  @Expose()
  urls: UrlDTO;

  @Expose()
  error: string;

  @Expose()
  userMediaAssetsMetadata: UserMediaAssetMetadataDTO[] = [];

  @Expose()
  @Transform(({ value, key, obj, type }) => {
    const userMediaAssetsMetadataObj: Record<string, { id: number | null; value: string }> = {};
    if (obj.userMediaAssetsMetadata) {
      obj.userMediaAssetsMetadata.map((metadata: UserMediaAssetMetadataDTO) => {
        userMediaAssetsMetadataObj[metadata.name] = {
          id: metadata.id ? metadata.id : null,
          value: metadata.value
        };
      });
    }
    return userMediaAssetsMetadataObj;
  })
  userMediaAssetsMetadataArr = {};

  file: File;

  selected: boolean;

  immediateUpload = true;

  soundUrlIsModified: boolean;

  modifiedInputField: string;
}
